export const TRANSLATION_ACTIONS = {
  FETCH_ALL_TRANSLATIONS_DATA_SUCCESS: "FETCH_ALL_TRANSLATIONS_DATA_SUCCESS",
  FETCH_TRANSLATIONS_DATA_FAILURE: "FETCH_TRANSLATIONS_DATA_FAILURE"
};
